import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import { SelectorBody } from '@components-shared/forms/Select/SelectorBody';
import { ISelectProps } from '@components-shared/forms/Select/types';
import { keyMap } from '@locales/lokalise/keyMap';
import { KeyMapKeys } from '@locales/lokalise/keyMap';

export const Select = (props: ISelectProps) => {
  const { i18n } = useTranslation();

  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    props.onChange?.(event.target.name, event.target.value);
  };

  const {
    name,
    title = '',
    chooseText,
    hideChooseText,
    options = [],
    attributes,
    className,
    valid,
    validationMessage,
    value = '',
    hintMessage,
    required,
    renderBefore = null,
    renderAfter = null,
    testID = 'formSelect',
    tooltip,
  } = props;

  const defaultSelectOption = chooseText ? i18n.t(chooseText as KeyMapKeys) : ` -- ${i18n.t(keyMap.formsChoose)} -- `;

  return (
    <InputFieldWrapper
      name={name}
      title={title}
      tooltip={tooltip}
      valid={valid}
      validationMessage={validationMessage}
      required={required}
      hintMessage={hintMessage}
      className={className}
      renderAfter={renderAfter}
      renderBefore={renderBefore}
      testID={testID}>
      <div className="form__select-wrapper">
        <SelectorBody
          defaultSelectOption={defaultSelectOption}
          onChange={onChange}
          options={options}
          value={value}
          valid={valid}
          attributes={attributes}
          hideChooseText={hideChooseText}
          name={name}
        />
      </div>
    </InputFieldWrapper>
  );
};
